import { motion } from "framer-motion";
import {
  Zap, Sparkles, ChefHat, ShieldCheck, FileCheck2, Store,
} from "lucide-react";

const COMMITMENTS = [
  {
    Icon: Zap,
    title: "Intervention rapide",
    text: "Déplacement rapide à Melun et dans toutes les villes alentour de Seine-et-Marne, y compris en horaires décalés pour ne pas interrompre votre service.",
  },
  {
    Icon: Sparkles,
    title: "Travail soigné et professionnel",
    text: "Démontage minutieux, nettoyage haute pression, finition impeccable. Photos avant/après remises à chaque intervention.",
  },
  {
    Icon: ChefHat,
    title: "Adapté aux cuisines pro",
    text: "Équipement et produits dégraissants alimentaires homologués, adaptés aux contraintes des cuisines de restaurant et de collectivité.",
  },
  {
    Icon: ShieldCheck,
    title: "Hygiène & sécurité",
    text: "Respect strict de l'arrêté du 25 juin 1980, des règles d'hygiène HACCP et des consignes de sécurité incendie en cuisine professionnelle.",
  },
  {
    Icon: FileCheck2,
    title: "Devis clair avant intervention",
    text: "Tarif transparent communiqué avant toute prestation. Aucune surprise, aucun frais caché, attestation officielle remise après chaque passage.",
  },
  {
    Icon: Store,
    title: "Restaurants, snacks, kebabs, boulangeries, collectivités",
    text: "Nous accompagnons restaurants traditionnels, brasseries, snacks, kebabs, pizzerias, boulangeries, traiteurs et cuisines collectives en Seine-et-Marne.",
  },
];

export default function QualityCommitments() {
  return (
    <section data-testid="quality-commitments-section" className="bg-[#f8fafc] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">
            Nos valeurs
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#00367e] leading-[1.1]">
            Nos engagements <span className="dh-underline">qualité</span>
          </h2>
          <p className="mt-5 text-lg text-slate-700">
            Un service local, rigoureux et conforme aux normes pour vous garantir une cuisine professionnelle propre, sûre et hygiénique.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {COMMITMENTS.map(({ Icon, title, text }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              data-testid={`commitment-card-${i}`}
              className="group bg-white rounded-3xl p-7 border border-slate-100 shadow-[0_8px_30px_rgb(0,54,126,0.06)] hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgb(0,54,126,0.12)] hover:border-[#066ec4]/30 transition-all duration-300 h-full flex flex-col"
            >
              <div className="w-14 h-14 rounded-2xl bg-[#f1f5fb] text-[#00367e] flex items-center justify-center mb-5 group-hover:bg-[#00367e] group-hover:text-white transition-colors">
                <Icon size={26} strokeWidth={2.2} />
              </div>
              <h3 className="text-xl font-bold text-[#00367e] leading-snug">{title}</h3>
              <p className="mt-3 text-slate-600 text-[15px] leading-relaxed">{text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
